import { render, staticRenderFns } from "./MoleculeSiteAndDepartmentDisplay.vue?vue&type=template&id=10f323bc&scoped=true&"
import script from "./MoleculeSiteAndDepartmentDisplay.vue?vue&type=script&lang=js&"
export * from "./MoleculeSiteAndDepartmentDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f323bc",
  null
  
)

export default component.exports